<template>
  <div>
    <div class="leave-list-wrap">
      <!-- <div class="leave-list-title">代接送审批</div> -->
      <div class="leave-list" v-if="list.length > 0">
        <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span>{{ item.pickUpPerson }}</span>
            <!-- <span
              class="status"
              v-if="item.leaveState == 0"
              @click.stop="changStatus(item)"
              >同意申请</span
            >
            <span class="status" v-if="item.leaveState == 1">已同意</span>
            <span class="status" v-if="item.leaveState == -1">已拒绝</span> -->
            <van-tag
              plain
              type="success"
              v-if="item.pickUpState == 1"
              size="medium"
              >已同意</van-tag
            >
            <van-tag
              plain
              type="primary"
              size="medium"
              v-if="item.pickUpState == 0"
              >待审批</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.pickUpState == -1"
              >已拒绝</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.pickUpState == -2"
              >已过期</van-tag
            >
          </div>
          <!-- <div class="date"><span>申请人：</span><span></span></div> -->
          <!-- <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.leaveBeginTime) }}</span>
          </div>-->
          <div class="date">
            <span>申请人：</span><span>{{ item.patriarchName }}</span>
          </div>
          <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.pickBeginTime) }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ getDateYMD(item.pickEndTime) }}</span>
          </div>
          <div class="date">
            <span>被接送人：</span>
            <span v-for="(v, index) in item.studentName">
              {{ v }}
              <span
                v-if="
                  item.studentName.length > 0 &&
                    index !== item.studentName.length - 1
                "
                >、</span
              >
            </span>
          </div>
          <!-- <div class="note">
            <span style="width: 4rem; display: inline-block; text-align: right;"
              >申请原因：</span
            ><span>{{ item.remark }}</span>
          </div> -->
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import { compare, getDateYMD, timeFormart } from '@/utils'

export default {
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getDateYMD,
    getList() {
      this.list = []
      Promise.all([
        this.getPickupAuditList(0),
        this.getPickupAuditList(1),
        this.getPickupAuditList(-1),
        // this.getPickupAuditList(-2),
      ]).then((res) => {
        if (res[0]) {
          this.$store.commit('setTabBadge', {
            type: 'pickup',
            value: res[0] ? res[0].length || '' : '',
          })
          res.forEach((item) => {
            item.forEach((v) => {
              this.list.push(v)
            })
          })
          console.log('0000000000000', this.list)
        }
      })
    },
    async getPickupAuditList(state) {
      const { data, code } = await this.$https.pickupAuditList({
        pickUpState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return false
      }
      return Promise.resolve(data)
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: '/pickupDetail',
        query: { id: item.id, type: 'au' },
      })
    },
    handleAudit(item) {
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: '是否通过？',
        })
        .then(() => {
          // on confirm
          this.pickupAudit(item)
        })
        .catch(() => {
          // on cancel
        })
    },
    async pickupAudit(item) {
      const { code } = await this.$https.pickupAudit({
        userId: this.$store.state.userId,
        leaveState: 1,
        id: item.id,
      })
      if (code !== 200) {
        this.$toast('审批失败')
        return
      }
      this.getList()
      this.$toast('成功')
    },
  },
}
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  .leave-list-title {
    color: #78849e;
    font-size: 0.75rem;
    margin: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;
      .c-left {
        flex: 1;
      }
      .c-right {
        width: 2.6875rem;
        height: 2.6875rem;
        text-align: center;
        line-height: 2.6875rem;
        font-size: 0.75rem;
        border-radius: 0.5rem;
        color: #fff;
        margin-left: 0.3rem;
        box-shadow: 0 0.75rem 1rem rgba(69, 91, 99, 0.1);
        background: #3acce1;
        /* width: 1.5rem;
        height: 1.5rem; */
      }
      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
        & > span:first-child {
          width: 4rem;
          display: inline-block;
          text-align: right;
        }
      }
    }
  }
}
</style>
